import { render, staticRenderFns } from "./OrgLeaderboardTeamView.vue?vue&type=template&id=0f7cd5e8&scoped=true&"
import script from "./OrgLeaderboardTeamView.vue?vue&type=script&lang=js&"
export * from "./OrgLeaderboardTeamView.vue?vue&type=script&lang=js&"
import style0 from "./OrgLeaderboardTeamView.vue?vue&type=style&index=0&id=0f7cd5e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7cd5e8",
  null
  
)

export default component.exports